import Vue from "vue";
import Router from "vue-router";

import Home from '@/components/home/home.vue'
import advanceSearch from '@/components/search/advanceSearch.vue'

import searchStandardsTitle from "@/components/standards/search/searchStandardsTitle.vue"
import searchStandardsContents from "@/components/standards/search/searchStandardsContents.vue"
import showStandards from "@/components/standards/show/showStandards.vue"

import searchRegulationsTitle from "@/components/regulations/search/searchRegulationsTitle.vue"
import searchRegulationsContents from "@/components/regulations/search/searchRegulationsContents.vue"
import showRegulations from "@/components/regulations/show/showRegulations.vue"

import tech from "@/components/tech/tech.vue"

// 测试部分， 目前不上线， 生产环境上线前，需注释掉
// import businessImpactModel from '@/components/business/businessImpactModel.vue'
// import bcm from "@/components/bcm/bcm.vue"
// import dev from "@/components/dev/dev.vue"
// import jsontable from "@/utils/json/jsontable.vue"
// import idc from "@/components/idc/idc.vue"

import VueRouter from "vue-router";

Vue.use(Router);

const routes = [{
    path: '/',
    redirect: "/Home"
  },
  {
    path: "/Home",
    component: Home,
    name: 'Home'
  },
  {
    path: "/advanceSearch",
    component: advanceSearch,
    name: 'advanceSearch'
  },
  {
    path: "/searchStandardsTitle",
    component: searchStandardsTitle,
    name: 'searchStandardsTitle'
  },
  {
    path: "/searchStandardsContents",
    component: searchStandardsContents,
    name: 'searchStandardsContents'
  },
  {
    path: "/showStandards",
    component: showStandards,
    name: 'showStandards'
  },
  {
    path: "/searchRegulationsTitle",
    component: searchRegulationsTitle,
    name: 'searchRegulationsTitle'
  },
  {
    path: "/searchRegulationsContents",
    component: searchRegulationsContents,
    name: 'searchRegulationsContents'
  },
  {
    path: "/showRegulations",
    component: showRegulations,
    name: 'showRegulations'
  },
  {
    path: "/tech",
    component: tech,
    name: 'tech'
  },
  // 测试部分， 目前不上线， 生产环境上线前，需注释掉
  // {
  //   path: "/businessImpactModel",
  //   component: businessImpactModel,
  //   name: 'businessImpactModel'
  // },
  // {
  //   path: "/bcm",
  //   component: bcm,
  //   name: 'bcm'
  // },
  // {
  //   path: "/dev",
  //   component: dev
  // },
  // {
  //   path: "/jsontable",
  //   component: jsontable
  // },
  // {
  //   path: "/idc",
  //   component: idc
  // }
]

const router = new VueRouter({
  mode: 'hash',
  routes: routes
})

export default router